export default {
  props: ['type', 'active', 'pointClass', 'pointValue'],
  computed: {
    // styles() {
    //     let styles = [];
    //     if (undefined != this.commonTheme) {
    //         styles.push(this.commonTheme)
    //     }
    //     if (this.type && undefined !== this.typeTheme) {
    //         let typeStyle = this.typeTheme[this.type];
    //         if (undefined !== typeStyle) {
    //             styles.push(typeStyle)
    //         }
    //         // let landscapeStyles = this.typeTheme[this.type + ".landscape"];
    //         // let portraitStyles = this.typeTheme[this.type + ".landsportraitcape"];
    //         // if (undefined !== landscapeStyles && window.clientWidth > window.clientHeight) {
    //         //     styles.push(landscapeStyles)
    //         // }
    //         // if (undefined !== portraitStyles && window.clientWidth < window.clientHeight) {
    //         //     styles.push(portraitStyles)
    //         // }
    //     }
    //     return styles;
    // }

    classes() {
      let classes = [];
      if (undefined != this.oceanuiClassName) {
        classes.push(this.oceanuiClassName);
        if (this.active) {
          classes.push(`${this.oceanuiClassName}-active`);
        }
      }
      if (undefined !== this.type) {
        classes.push(this.oceanuiClassName + '-' + this.type);
        if (this.active) {
          classes.push(`${this.oceanuiClassName}-${this.type}-active`);
        }
      }
      return classes;
    },
  },
  methods: {
    passMethod(methodName) {
      this.$emit(methodName || 'click');
    },
  },
};
